export class AbstractKappasFlatten {

  constructor(application?: number, projectNumber?: string,
    fY?: number, type?: number, mechanism?: string, statusDate?: string,
    projectTitle?: string,
    //pIName?: string, descPart?: string, publicHealthPart?: string, flags?: string, a1?: string, a2?: string,
    //a3?: string, a4?: string, d?: string, e?: string, f?: string, g?: string, reviewRecommended?: string) {
    pIName?: string, descPart?: string, publicHealthPart?: string, hasNotes?: string, a?: string, b?: string,
    c?: string, d?: string, e?: string, f?: string, x?: string, inQcList?: string, reviewRequested?: string, 
    adjudicationRequested?: string, submissionAgreePriorityTitle?: string,
    subcategoryGroupTitle?: string, teamcoders?: string) {

    this.ApplicationID = application;
    this.ProjectNumber = projectNumber;
    this.FY = fY;
    this.Type = type;
    this.Mech = mechanism;
    this.StatusDate = statusDate;
    this.Title = projectTitle;
    this.PIName = pIName;
    this.Description = descPart;
    this.PublicHealthPart = publicHealthPart;
    this.HasNotes = hasNotes;

    //this.A1 = a1;
    //this.A2 = a2;
    //this.A3 = a3;
    this.A = a;
    this.B = b;
    this.C = c;
    this.D = d;    
    this.E = e;
    this.F = f;
    this.X = x;
    /*    this.G = g;*/
    this.InQcList = inQcList;
    this.ReviewRequested = reviewRequested;
    this.AdjudicationRequested = adjudicationRequested;
    this.SubmissionAgreePriorityTitle = submissionAgreePriorityTitle;
    this.SubcategoryGroupTitle = subcategoryGroupTitle;
    this.Coders = teamcoders;
  }

  public ApplicationID: number;
  public ProjectNumber: string;
  public FY: number;
  public Type: number;
  public Mech: string;
  public StatusDate: string;
  public PIName: string;
  public Title: string;
  public Description: string;
  public PublicHealthPart: string;
  public HasNotes: string;

  //public A1: string;
  //public A2: string;
  //public A3: string;
  public A: string;
  public B: string;
  public C: string;
  public D: string;
  public E: string;
  public F: string;
  public X: string;
  /*  public G: string;*/
  public InQcList: string;
  public ReviewRequested: string;
  public AdjudicationRequested: string;
  public SubmissionAgreePriorityTitle: string;
  public SubcategoryGroupTitle: string;
  public Coders: string;

}

